import React from 'react';
import Popup from '../../../common/Popup/Popup';
import './AttentionPopup.css';

/**
 * AttentionPopup Component
 * 
 * Displays a popup with an attention heading and a message.
 * 
 * @param {Function} closeModal - Function to close the popup
 */
const AttentionPopup = ({ closeModal, children, color = '#007bff' }) => {
  return (
    <div className="attention-popup-wrapper">
      <Popup 
        closeModal={closeModal}
        title={null}
        small={true}
        headerStyle={{ padding: '1.5rem 3.5rem 1rem 1.5rem' }}
        customHeading={
          <h2 className={`tasks-copied-title`} style={{color: color}}>Attention!</h2>
        }
      >
        <div className="tasks-copied-content">
          {children}
        </div>
      </Popup>
    </div>
  );
};

export default AttentionPopup;

